import { useSelector } from 'react-redux'
import { getPaymentRouteType, getSelectedPlanValue } from 'ducks/trialWarning'

const SwitchToYearlyButton = ({ planType, isAnnual, submitting, onToggle }) => {
  const paymentRouteType = useSelector(getPaymentRouteType)
  const selectedPlanValue = useSelector(getSelectedPlanValue)

  const hasTheSamePlanType =
    paymentRouteType === 'upgrade' && selectedPlanValue === planType

  if (hasTheSamePlanType) {
    return null
  }

  if (isAnnual) {
    return (
      <a className="pay-monthly-btn" onClick={!submitting && onToggle}>
        No thanks, I'll pay the full monthly price
      </a>
    )
  }

  return (
    <a className="switch-to-yearly-btn" onClick={!submitting && onToggle}>
      SWITCH TO YEARLY SAVE 20%
    </a>
  )
}

export default SwitchToYearlyButton
